import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { DaTableCell, DaTableRow, Text } from '@paygreen/paygreen-ui';
import { IsBigDesktop } from '../../utils/tools';
import { Disabler } from '../../components';
import ActionsCell from './ActionsCell';

const MemoizedRow = memo(
    ({ t, row, isActive, className, updateUserSector, userSector }) => {
        // needed to guarantee vertical alignment on tablet for last cell in table
        const actionCellboxProps = {
            style: {
                display: IsBigDesktop() ? null : 'flex',
                justifyContent: IsBigDesktop() ? null : 'flex-end',
                overflow: 'visible',
            },
        };

        const { id, emission, domain, name } = row.values;

        return (
            <DaTableRow
                {...row.getRowProps()}
                key={row.id}
                isActive={isActive}
                className={className}
                style={{ gridTemplateColumns: '1fr auto' }}
            >
                <DaTableCell label={t('categories.table.name')} title={name}>
                    {name}
                </DaTableCell>
                <DaTableCell
                    isMain={false}
                    label={t('sectors.table.domain')}
                    title={domain}
                >
                    {domain}
                </DaTableCell>
                <DaTableCell
                    isMain={false}
                    label={t('sectors.table.emission')}
                    title={emission}
                >
                    <span>
                        <Text textSize="sm" htmlTag="strong">
                            {emission}
                        </Text>{' '}
                        {t('sectors.table.unit')}
                    </span>
                </DaTableCell>
                <DaTableCell label="Actions" {...actionCellboxProps}>
                    <Disabler>
                        <ActionsCell
                            sector={id}
                            name={name}
                            updateUserSector={updateUserSector}
                            isSelected={userSector?.id === id}
                        />
                    </Disabler>
                </DaTableCell>
            </DaTableRow>
        );
    },
);

MemoizedRow.propTypes = {
    isActive: PropTypes.bool,
    className: PropTypes.string,
    row: PropTypes.object,
};

MemoizedRow.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(MemoizedRow);
